const regexEmail = new RegExp("^\\w+([.-]?\\w+)*@\\w+([.-]?\\w+)*(\\.\\w{2,3})+$");

export default {
  isEmailValid(email) {
    return regexEmail.test(email);
  },
};
